import { Add as AddIcon, MoreHoriz as MoreHorizIcon, Phone as PhoneIcon, Room as RoomIcon, Person as PersonIcon } from '@mui/icons-material';
import TextFieldMask from 'components/TextFieldMask';
import { Field, Phone } from 'models';
import STATE_SELECTION_ITEMS from './statesItems';
var CUSTOMER_SECTION_FORM = {
    basic: {
        header: {
            Icon: PersonIcon,
            title: 'BASIC'
        },
        prefix: 'person',
        item: {
            firstName: {
                hasFilter: true,
                inputProps: { label: 'First Name', required: true }
            },
            middleName: { inputProps: { label: 'Middle Name' } },
            lastName: {
                hasFilter: true,
                inputProps: { label: 'Last Name', required: true }
            },
            gender: {
                inputProps: {
                    hasEndCopyIcon: false,
                    label: 'Gender',
                    selectItems: [
                        { label: 'Other', value: 'O' },
                        { label: 'Female', value: 'F' },
                        { label: 'Male', value: 'M' }
                    ]
                }
            },
            dateOfBirth: {
                formType: 'datePicker',
                hasFilter: true,
                inputProps: { label: 'Date of Birth' }
            },
            email: { inputProps: { label: 'Email' } }
        }
    },
    phones: {
        header: {
            Icon: PhoneIcon,
            actionProps: {
                Icon: AddIcon,
                execute: function () { return undefined; },
                tooltipText: 'Add Phone Number'
            },
            title: 'PHONES'
        },
        items: {
            hasFilter: true,
            inputProps: {
                InputProps: {
                    inputComponent: TextFieldMask('(###) ###-####')
                }
            },
            xs: 11,
            getCustomItemLabel: function (index) {
                return "Phone ".concat(index + 1).concat(index > 0 ? '' : ' (preferred)');
            },
            getCustomItemName: function (index) {
                return "person.phones.".concat(index, ".phoneNumber");
            },
            getHasFilter: function (index) { return index === 0; },
            getRequired: function (index) { return index === 0; }
        },
        maxItems: 6,
        prefix: 'person.phones',
        sectionsIndex: 1,
        getNewItemModel: function () { return new Phone(); }
    },
    address: {
        header: {
            Icon: RoomIcon,
            title: 'ADDRESS'
        },
        prefix: 'person.address',
        item: {
            line1: { inputProps: { label: 'Street 1' } },
            line2: { inputProps: { label: 'Street 2' } },
            city: { inputProps: { label: 'City' } },
            state: {
                formType: 'autocomplete',
                hasFilter: true,
                inputProps: {
                    label: 'State',
                    selectItems: STATE_SELECTION_ITEMS,
                    showDropDownIcon: false
                }
            },
            county: { inputProps: { label: 'County' } },
            zipcode: {
                hasFilter: true,
                inputProps: {
                    label: 'Zipcode',
                    InputProps: {
                        inputComponent: TextFieldMask('#####')
                    }
                }
            }
        }
    },
    fields: {
        header: {
            Icon: MoreHorizIcon,
            title: 'FIELDS'
        },
        items: {
            inputProps: {
                disabled: true
            },
            getCustomItemLabel: function (_, item) { return item.key; },
            getCustomItemName: function (index) { return "fields.".concat(index, ".value"); }
        },
        prefix: 'fields',
        sectionsIndex: 3,
        getNewItemModel: function () { return new Field(); }
    }
};
export default CUSTOMER_SECTION_FORM;
//# sourceMappingURL=customerSectionForm.js.map